
import { Component, Provide, Mixins } from 'vue-property-decorator';
import StudentCoursesModal from '../../advisorSystem/modals/StudentCourses.vue';

@Component({})
export default class StudentCourses extends Mixins(StudentCoursesModal) {
    @Provide() public isAdvisor: boolean = false;
}
